import { Box } from "@mui/material";
import tip from "components/geo-quality-tooltip/geo-quality-tooltip";
import Icon from "components/icon/icon";
import { Tooltip } from "react-tooltip";
import { TableHeadSortLabel } from "./TableHeadSortLabel";

type SortableProperties = "name" | "address" | "quality" | "aggregationUnit" | "currency";

interface Props {
	activeSort: { property: SortableProperties; direction: "asc" | "desc" };
	handleSort: (property: SortableProperties) => void;
	t: (key: string) => string;
	hideSortIcon?: boolean;
}

export function GeoQualityCell({ activeSort, handleSort, t, hideSortIcon }: Props) {
	return (
		<TableHeadSortLabel
			property="quality"
			activeSort={activeSort}
			handleSort={handleSort}
			width="30%"
			colSpan={2}
			hideSortIcon={hideSortIcon}
			onClick={(e) => e.stopPropagation()}
		>
			{t("addressEncoding.table.geoQuality")}
			<Box data-tooltip-id="address-tooltip" data-tooltip-html={tip(t)} component="span">
				<Icon icon="info" style={{ color: "#666" }} />
			</Box>
			<Tooltip id="address-tooltip" style={{ maxWidth: "300px", width: "300px", fontSize: "13px", zIndex: "99999" }} />
		</TableHeadSortLabel>
	);
}